import React, { useState } from 'react';
import { Alert, Button, Badge } from 'react-bootstrap';
import { FaClock, FaKey, FaTimes } from 'react-icons/fa';
import { useLicense } from '../../context/LicenseContext';
import LicenseEntryModal from './LicenseEntryModal';

const LicenseWarning = () => {
  const { licenseStatus, shouldShowWarning, getDaysRemaining, getLicenseType } = useLicense();
  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleLicenseUpdated = () => {
    setShowLicenseModal(false);
    setDismissed(false); // Show warning again if still needed after update
  };

  // Don't show warning if not needed or if dismissed
  if (!shouldShowWarning() || dismissed) {
    return null;
  }

  const daysRemaining = getDaysRemaining();
  const licenseType = getLicenseType();
  
  const getVariant = () => {
    if (daysRemaining <= 1) return 'danger';
    if (daysRemaining <= 3) return 'warning';
    return 'info';
  };

  const getIcon = () => {
    return <FaClock className="me-2" />;
  };

  return (
    <>
      <Alert 
        variant={getVariant()} 
        className="mb-3"
        dismissible={false}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            {getIcon()}
            <div>
              <strong>
                {daysRemaining === 1 ? 'License Expires Tomorrow!' : 
                 daysRemaining <= 3 ? 'License Expiring Soon!' : 
                 'License Expiration Notice'}
              </strong>
              <div className="small">
                Your {licenseType?.toLowerCase()} license will expire in {' '}
                <strong>{daysRemaining} day{daysRemaining !== 1 ? 's' : ''}</strong>
                {' '}on {new Date(licenseStatus?.expirationDate).toLocaleDateString()}.
                {daysRemaining <= 3 && ' Please renew immediately to avoid service interruption.'}
              </div>
            </div>
          </div>
          
          <div className="d-flex align-items-center gap-2">
            <Badge bg={getVariant()}>
              {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} left
            </Badge>
            
            <Button 
              variant={`outline-${getVariant()}`}
              size="sm"
              onClick={() => setShowLicenseModal(true)}
            >
              <FaKey className="me-1" />
              Renew License
            </Button>
            
            <Button 
              variant="outline-secondary"
              size="sm"
              onClick={() => setDismissed(true)}
              title="Dismiss this warning"
            >
              <FaTimes />
            </Button>
          </div>
        </div>
      </Alert>
      
      <LicenseEntryModal 
        show={showLicenseModal}
        onHide={() => setShowLicenseModal(false)}
        onLicenseUpdated={handleLicenseUpdated}
        currentStatus={licenseStatus}
      />
    </>
  );
};

export default LicenseWarning;
